export default __webpack_public_path__ + "static/media/trbothh2.c5bc0aa4.mp3";